import React, { Component } from "react";
import { Modal, Form, Input, Col, Row, Button } from "antd";
import { strings } from "../../helpers";
import { generateCmsData } from "../../services";
const FormItem = Form.Item;

export default class DemoDetailModal extends Component {
  render() {
    const {
      userPhoneNumber,
      openDetailModal,
      toggleDetailModal,
      generateData,
      isProcessing,
      handleInputChange
    } = this.props;

    return (
      <Modal
        visible={openDetailModal}
        title="Generate Data"
        footer={null}
        onCancel={toggleDetailModal}
        className="form-type-modal"
      >
        <Form layout="vertical">
          <FormItem label="Enter clinic's phone number">
            <Input
              value={userPhoneNumber}
              onChange={handleInputChange}
              maxLength={10}
            ></Input>
          </FormItem>
          <FormItem>
            <Row type="flex" gutter={20}>
              <Col>
                <Button type="primary">Cancel</Button>{" "}
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={generateData}
                  loading={isProcessing}
                >
                  Generate
                </Button>
              </Col>
            </Row>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}
